/** InsCoder WANG.J 2026-08-17 B + Weekly Launch Offer 2 theme editor lifecycle **/

(function () {
  function initialize(root) {
    if (!root || root.dataset.custWeeklyLaunchOffer2Ready === 'true') return;
    root.dataset.custWeeklyLaunchOffer2Ready = 'true';
  }

  function initializeAll() {
    document.querySelectorAll('[data-cust-weekly-launch-offer-2]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target.querySelector('[data-cust-weekly-launch-offer-2]'));
  });
})();

/** InsCoder WANG.J 2026-08-17 E + Weekly Launch Offer 2 theme editor lifecycle **/
